export const MCP_ENDPOINT = 'https://mcp.transpond.io/mcp'

export const CURSOR_DEEPLINK =
  'cursor://anysphere.cursor-deeplink/mcp/install?name=transpond&config=eyJ1cmwiOiJodHRwczovL21jcC50cmFuc3BvbmQuaW8vbWNwIn0='

export const VSCODE_DEEPLINK =
  'vscode:mcp/install?%7B%22name%22%3A%22transpond%22%2C%22type%22%3A%22http%22%2C%22url%22%3A%22https%3A//mcp.transpond.io/mcp%22%7D'

export const PLATFORM_IDS = [
  'claude',
  'chatgpt',
  'gemini',
  'claude-code',
  'cursor',
  'vscode',
  'codex',
  'copilot',
  'droid',
  'opencode',
  'generic'
]

const SNIPPETS = {
  'claude-code': `claude mcp add --transport http transpond ${MCP_ENDPOINT}`,
  cursor: `{
  "mcpServers": {
    "transpond": {
      "url": "${MCP_ENDPOINT}"
    }
  }
}`,
  vscode: `{
  "servers": {
    "transpond": {
      "type": "http",
      "url": "${MCP_ENDPOINT}"
    }
  }
}`,
  codex: `[mcp_servers.transpond]
url = "${MCP_ENDPOINT}"`,
  copilot: `{
  "mcpServers": {
    "transpond": {
      "type": "http",
      "url": "${MCP_ENDPOINT}",
      "tools": ["*"]
    }
  }
}`,
  droid: `droid mcp add transpond ${MCP_ENDPOINT} --type http`,
  opencode: `{
  "$schema": "https://opencode.ai/config.json",
  "mcp": {
    "transpond": {
      "type": "remote",
      "url": "${MCP_ENDPOINT}",
      "enabled": true
    }
  }
}`,
  generic: `{
  "mcpServers": {
    "transpond": {
      "url": "${MCP_ENDPOINT}"
    }
  }
}`
}

/**
 * @param {string} platformId
 * @returns {string|null}
 */
export function getPlatformSnippet(platformId) {
  return SNIPPETS[platformId] || null
}
